import { InterestCalculationResponse } from "../../../models/interestCalculation/interestCalculationResponse";

export const getInterestCalculatorSet = {
  loanAmount: 310000.4,
  balanceToDate: 310612.7555,
  accruedInterest: 612.355,
} as InterestCalculationResponse;
